import Visualizations from './all-visualizations/all-visualizations.json';
import AreaChart from './all-visualizations/AreaChart.json';
import BarChart from './all-visualizations/BarChart.json';
import ColumnChart from './all-visualizations/ColumnChart.json';
import Gauge from './all-visualizations/Gauge.json';
import HeatMap from './all-visualizations/HeatMap.json';
import LineChart from './all-visualizations/LineChart.json';
import PieChart from './all-visualizations/PieChart.json';
import ScatterPlot from './all-visualizations/ScatterPlot.json';
import StackedCartesian from './all-visualizations/StackedCartesian.json';
import AreaChartDetail from './detail-views/area-chart/AreaChartDetail.json';
import DetailOverview from './detail-views/DetailOverview.json';
import AreaChartDetailExamples from './detail-views/area-chart/AreaChartDetailExamples.json';
import Inspector from './detail-views/Inspector.json';
import AreaChartDetailOptions from './detail-views/area-chart/AreaChartDetailOptions.json';
import PropertyCard from './detail-views/PropertyCard.json';

export default [
  Visualizations,
  AreaChart,
  BarChart,
  ColumnChart,
  Gauge,
  HeatMap,
  LineChart,
  PieChart,
  ScatterPlot,
  StackedCartesian,
  AreaChartDetail,
  DetailOverview,
  AreaChartDetailExamples,
  Inspector,
  AreaChartDetailOptions,
  PropertyCard,
];
